module.exports = __webpack_public_path__ + "img/zt.0d7b0e72.svg";